<template>
  <v-container fluid>
    <v-card color="#F5B93F" class="mb-3">
      <v-card-title>Наши врачи</v-card-title>
    </v-card>
    <v-card color="#F5B93F" class="mb-3" style="height: 80vh">
      <v-card-text class="d-flex justify-center">
        <v-row>
          <v-col cols="12" md="4" >
            <v-card height="500px" color="background">
<!--              <v-img-->
<!--                  :src="getUrl + item.img"-->
<!--                  height="200"-->
<!--                  aspect-ratio="2"-->
<!--              ></v-img>-->
              <v-card-title>Ланец Татьяна Витальевна</v-card-title>
              <v-card-text class=" size-card-text truncate-text">врач стоматолог-терапевт</v-card-text>
<!--              <v-card-actions class="justify-center align-center text-center btn-down"><v-btn color="primary" :to="`/service/post/${item.id}`">Подробнее</v-btn></v-card-actions>-->

            </v-card>
          </v-col>
          <v-col cols="12" md="4" >
            <v-card height="500px" color="background">
<!--              <v-img-->
<!--                  :src="getUrl + item.img"-->
<!--                  height="200"-->
<!--                  aspect-ratio="2"-->
<!--              ></v-img>-->
              <v-card-title class="text-center">Гараев Александр Харисович</v-card-title>
              <v-card-text class=" size-card-text truncate-text">врач стоматолог-ортопед</v-card-text>
<!--              <v-card-actions class="justify-center align-center text-center btn-down"><v-btn color="primary" :to="`/service/post/${item.id}`">Подробнее</v-btn></v-card-actions>-->

            </v-card>
          </v-col>
          <v-col cols="12" md="4" >
            <v-card height="500px" color="background">
<!--              <v-img-->
<!--                  :src="getUrl + item.img"-->
<!--                  height="200"-->
<!--                  aspect-ratio="2"-->
<!--              ></v-img>-->
              <v-card-title>Виценко Данил Иванович</v-card-title>
              <v-card-text class=" size-card-text truncate-text">врач стоматолог хирург,имплантолог</v-card-text>
<!--              <v-card-actions class="justify-center align-center text-center btn-down"><v-btn color="primary" :to="`/service/post/${item.id}`">Подробнее</v-btn></v-card-actions>-->

            </v-card>
          </v-col>

        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Doctors",
  data: () => ({}),
};
</script>
